import { render, staticRenderFns } from "./NpsScoreTableTab.vue?vue&type=template&id=320782dd&scoped=true&"
import script from "./NpsScoreTableTab.vue?vue&type=script&lang=ts&"
export * from "./NpsScoreTableTab.vue?vue&type=script&lang=ts&"
import style0 from "./NpsScoreTableTab.vue?vue&type=style&index=0&id=320782dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320782dd",
  null
  
)

export default component.exports